
import React, { FC } from 'react';
import { NavLink } from 'react-router';
import { RoutePaths } from 'routes/RoutePaths';

const HeaderLogo: FC<{
    otherUser: string | undefined
}> = ({ otherUser }) => {
    return <NavLink
        end
        to={RoutePaths.Subscriptions.AllActive.url(otherUser)}
        className="navbar-title-link">

        <div className="navbar-logo">
            <img src="https://shared.sgmarkets.com/assets/images/logo/socgen_logo.svg" alt="SG logo Glyph" />
        </div>

        <div className="navbar-title-divider" />
        <div className="navbar-service-name">
            Subscriptions
        </div>
    </NavLink >;
};

export default HeaderLogo;